import React, { useEffect, useRef } from 'react';
import './MobileReimagine.css';
import { Link } from 'react-router-dom';

const cards = [
  {
    id: 1,
    title: 'EDUCATION',
    desc: 'From e-learning platforms to student management systems, empower your educational institutions to deliver seamless and immersive learning experiences and embrace the future of education.',
    bg: '/images/fintech.webp',
  },
  {
    id: 2,
    title: 'HEALTHTECH',
    desc: 'By embracing digital transformation in your healthcare practice, youre not only catering to the changing preferences of your existing patients but also positioning yourself to attract new ones.',
    bg: '/images/healthcare.webp',
  },
  {
    id: 3,
    title: 'HOSPITALITY',
    desc: "Redefine hospitality, from streamlined booking systems to personalized guest experiences, we help you optimize every aspect of your operations, ensuring a modern and delightful stay for your guests.",
    bg: '/images/technology.avif',
  },
];

const ReimagineSection = () => {
  const refs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    refs.current.forEach(ref => ref && observer.observe(ref));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="reimagine-section">
      <div className="reimagine-header">
        <h2 className="fade-left" ref={el => refs.current[0] = el}>
          WE HELP <span className="blue">REIMAGINE INDUSTRIES</span>
        </h2>
        <p className="fade-right" ref={el => refs.current[1] = el}>
          Since 2010, we’ve accerelated more than 300 web, software and mobile application services.
        </p>
      </div>

      <div className="reimagine-cards">
        {cards.map((card, i) => (
          <div
            className="reimagine-card20 fade-up"
            key={card.id}
            ref={el => refs.current[i + 2] = el}
            style={{ backgroundImage: `url(${card.bg})` }}
          >
            <div className="card-overlay652">
              <h3 className="card-title652">{card.title}</h3>
              <div className="card-hover-content">
                <p>{card.desc}</p>
                <span className="explore-arrow">→ EXPLORE</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="reimagine-btn">
        <Link to="/industries">
        <button>SEE ALL INDUSTRIES</button>
        </Link>
      </div>
    </section>
  );
};

export default ReimagineSection;
